<template>
  <AppModal
    modal-class="rounded-md min-w-[80vw]"
    :body-scroll="false"
    fill-screen
    @cancel="onCancel"
  >
    <AppDataGrid
      grid-name="grid"
      :resource-url="customResourceUrl || resource.uri"
      :resource-key="resource.name"
      :grid-key="gridKey"
      :filters="filters"
      :on-row-selected="
        (e) => (selection = e.api.getSelectedRows().map((r) => r.id))
      "
      :row-class-rules="defineGridColors(resource.name)"
      :on-row-double-clicked="(e) => onConfirm(e.data.id)"
      :row-selection="selectionMode"
    >
      <template #toolbar>
        <span />
      </template>
    </AppDataGrid>
    <template #footer>
      <div
        class="absolute bottom-20 right-12 flex flex-row gap-2 bg-gray-700 rounded-xl shadow-xl p-3"
      >
        <AppButton @click="onCancel">
          Annuleren
        </AppButton>
        <AppButton
          :disabled="selection.length == 0"
          @click="onConfirm(undefined)"
        >
          Selectie bevestigen ({{ selection.length }})
        </AppButton>
      </div>
    </template>
  </AppModal>
</template>

<script setup lang="ts">
import { Resource } from "@q-food/q-food";
import { lotStatusColor } from "~utils/Grids/StatusColorRules.ts";

function defineGridColors(resourceName: string) {
	switch (resourceName) {
		case "lot":
			return lotStatusColor();
		default:
			return null;
	}
}

const props = withDefaults(
	defineProps<{
		resource: Resource;
		gridKey?: string;
		selectionMode?: "singleRow" | "multiRow";
		customResourceUrl?: string;
		filters?: string;
	}>(),
	{
		selectionMode: "singleRow",
	},
);

const { customResourceUrl, resource } = toRefs(props);
const selection = ref<string[]>([]);

function onConfirm(value?: string) {
	if (typeof value === "string") {
		return emit("confirm", [value]);
	} else if (selection.value.length > 0) {
		return emit("confirm", selection.value);
	}
}

function onCancel() {
	selection.value = [];
	emit("cancel");
}

const emit = defineEmits<{
	(e: "confirm", value: string[]): void;
	(e: "cancel"): void;
}>();

const { escape, enter } = useMagicKeys();
whenever(escape, () => {
	onCancel();
});

whenever(enter, () => {
	onConfirm();
});
</script>

<style scoped></style>
